import filter from 'lodash/filter';
import { scriptStepTypes } from '@xmatters/common/constants/scriptSteps';

function updateAvailableItemsContents(items) {
  const isCallableFlowFeatureToggleEnabled = items.some(
    item => item?.featureToggle === 'CALLABLE_FLOW_MVP',
  );
  return items.map(item => {
    if (item.integrationType === scriptStepTypes.CREATE_EVENT) {
      return {
        ...item,
        descriptionId: 'FLOW_DESIGN_CREATE_EVENT_DESCRIPTION',
      };
    }
    // Content of INBOUND_EMAIL should be updated if featureToggle 'CALLABLE_FLOW_MVP' is enabled
    if (
      item.integrationType === scriptStepTypes.INBOUND_EMAIL &&
      isCallableFlowFeatureToggleEnabled
    ) {
      return {
        ...item,
        name: 'Email Initiation',
        scriptStepType: scriptStepTypes.INBOUND_EMAIL_UTILITIES,
        descriptionId: 'DESCRIPTION_INBOUND_EMAIL_UTILITY',
      };
    }
    return item;
  });
}

/**
 * Determine if a single flag, or a list of flag, is enabled.
 * If a list of toggles is provided, all toggles must be enabled to return true.
 * @param {string|string[]} toggle - a toggle, or a list of toggles
 * @param {object} map - store.featureToggles.featureToggleMap
 * @returns {boolean}
 */
export function isToggleEnabled(toggle, map) {
  if (!Array.isArray(toggle)) {
    return !toggle || map[toggle] === 'true';
  }
  return toggle.every(individualToggle => {
    return map[individualToggle] === 'true';
  });
}

/**
 * Returns all available palette items with featureToggle enabled
 * @param {Array<Object>} availableDefaultFeatures - all features
 * @param {Object} featureToggleMap - map of features values {featureName: true/false,...}
 * @returns {Array<Object>} - all available features
 */
export const getAvailablePaletteItems = (
  availableDefaultFeatures,
  featureToggleMap,
) => {
  const productName = featureToggleMap.PRODUCT_NAME ?? '';
  return filter(
    availableDefaultFeatures,
    ({ featureToggle, isEnabledForProduct }) => {
      return (
        isToggleEnabled(featureToggle, featureToggleMap) &&
        (!isEnabledForProduct || isEnabledForProduct(productName))
      );
    },
  );
};

/**
 * Returns all UPDATED available palette items with featureToggle enabled
 * @param {Array<Object>} availableDefaultFeatures - all features
 * @param {Object} featureToggleMap - map of features values {featureName: true/false,...}
 * @returns {Array<Object>} - all UPDATED available features
 */
export const getUpdatedAvailablePaletteItems = (
  availableDefaultFeatures,
  featureToggleMap,
) => {
  const availableItems =
    getAvailablePaletteItems(availableDefaultFeatures, featureToggleMap) || [];
  const updatedAvailableItems = updateAvailableItemsContents(availableItems);
  return updatedAvailableItems;
};
